import request from '@/utils/request'

/**
 * 获取物品类型列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listResourceStoreTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceStoreType.listResourceStoreTypes',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加物品类型
 * @param {Object} data 物品类型数据
 * @returns {Promise} Promise对象
 */
export function saveResourceStoreType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceStoreType.saveResourceStoreType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新物品类型
 * @param {Object} data 物品类型数据
 * @returns {Promise} Promise对象
 */
export function updateResourceStoreType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceStoreType.updateResourceStoreType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除物品类型
 * @param {Object} data 删除参数
 * @returns {Promise} Promise对象
 */
export function deleteResourceStoreType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceStoreType.deleteResourceStoreType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}